/**
 * Fusión de una página del historial del server con el hilo que ya está en
 * pantalla.
 *
 * El hilo visible se arma de dos fuentes: el historial local (30 días,
 * localHistory.js) y las páginas que devuelve el server. Con el historial del
 * abonado —que cruza dispositivos— las dos se superponen: el server vuelve a
 * traer mensajes que este navegador ya tenía guardados.
 *
 * La regla es por RANGO, no por id: una página cubre, de cada conversación que
 * toca, desde su mensaje más viejo en adelante. Dentro de ese rango manda el
 * server; antes del rango se conserva lo local (esa página todavía no se
 * pidió), y las conversaciones que la página no toca quedan intactas.
 *
 * Un dedupe por id no alcanzaría: los mensajes que el front pintó en vivo se
 * guardan sin `id` (el server no le devuelve uno al webchat en el momento), y
 * al volver por historial aparecerían dos veces.
 */
export function mergeHistoryPage(local, incoming) {
  if (!incoming?.length) return local;

  const coveredFrom = new Map();
  for (const m of incoming) {
    const from = coveredFrom.get(m.convId);
    if (from === undefined || m.ts < from) coveredFrom.set(m.convId, m.ts);
  }
  const incomingIds = new Set(incoming.map((m) => m.id).filter(Boolean));

  const kept = (local || []).filter((m) => {
    if (m.id && incomingIds.has(m.id)) return false;
    const from = coveredFrom.get(m.convId);
    return from === undefined || m.ts < from;
  });

  // Orden estable por timestamp: los tramos viejos entran antes que el hilo de
  // hoy aunque hayan llegado después.
  return [...kept, ...incoming].sort((a, b) => (a.ts || 0) - (b.ts || 0));
}
